import './popover-got-it.scss';
import React from 'react';
import { Popover, PopoverProps } from 'antd';
import CustomButton from '../custom-button/custom-button';

interface PopoverGotItProps {
    open: boolean;
    placement?: PopoverProps['placement'];
    overlayClassName?: string;
    text?: string;
    title?: string;
    content?: React.ReactNode;
    children?: React.ReactNode;
    onClickGotIt?: () => void;
}

export const PopoverGotIt: React.FC<PopoverGotItProps> = ({ open, overlayClassName, placement, text, title, content, children, onClickGotIt }) => {
    return (
        <Popover
            overlayClassName={`popover-got-it-popover ${overlayClassName ?? ''} ${content ? 'popover-got-it-custom-content' : ''}`}
            open={open}
            placement={placement || 'bottom'}
            destroyTooltipOnHide
            content={
                <div className="popover-got-it">
                    {content && <div className="popover-got-it-custom-content">{content}</div>}
                    {title && <div className="popover-got-it-title">{title}</div>}
                    <span className="text">{text}</span>
                    <div className="footer">
                        <CustomButton className={'pending-version-close-btn primary-btn'} label="Got it"
                                      onClick={e => {
                                          e.stopPropagation();
                                          onClickGotIt?.();
                                      }} />
                    </div>
                </div>
            }
        >
            {children}
        </Popover>
    );
};